export default __webpack_public_path__ + "static/media/revert_button.f09744fc.svg";